import { render } from "./TabNav3.vue?vue&type=template&id=f1fd030e"
import script from "./TabNav3.vue?vue&type=script&lang=js"
export * from "./TabNav3.vue?vue&type=script&lang=js"

import "./TabNav3.vue?vue&type=style&index=0&id=f1fd030e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__